import React, { useState, useEffect, useContext } from 'react';
import FileBUUploadModalNew from './FileBUUploadModalNew';
import { deleteFromCache, saveToCache, loadTitleCache, loadFromCacheBu } from './CacheHandler';
import { FaRegFilePdf, FaFilePowerpoint, FaRegFileExcel, FaFileWord, FaFile, FaFolderOpen } from 'react-icons/fa';
import { ModeContext } from './ModeContext';
import ListItemButton from '@mui/material/ListItemButton';
import {
  Box,
  Typography,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Collapse,
  Divider
} from '@mui/material';　
import { ExpandLess, ExpandMore, ControlPoint } from '@mui/icons-material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { LoadToCosmos } from './SendToCosmos';

const SettingsDocUpNew = () => {
  const [loading, setLoading] = useState(true);
  const [openItems, setOpenItems] = useState({});
  const [openCategories, setOpenCategories] = useState({});
  const [isNewModalOpen, setIsNewModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const { filebuList, setFilebuList } = useContext(ModeContext);

  //画面更新用
  const handleUpdateComplete = () => {
    fetchFileListbu();
  };

  // 事業部ごと・カテゴリごとにデータを整理
  const fetchFileListbu = async () => {
    try {
      const uppayload = { id: 'all', container: 'con-concierge-filebunew' };
      const items = await LoadToCosmos(uppayload);
      const grouped = {};

      items.item.forEach((bu) => {
        const buId = bu.id;
        grouped[buId] = {};
        //saveToCache(buId,'chat-bufilenew-cache','' ,bu.messages,'','',''); 
        // bu.messages は「配列」
        if (Array.isArray(bu.messages)) {
          bu.messages.forEach((cat) => {
            const catName = cat.category || '未分類';
            
            grouped[buId][catName] = cat.messages || [];
          });
        }
      });

      setFilebuList(grouped);
    } catch (error) {
      console.error('データ取得エラー:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFileListbu();
  }, []);

  const handleToggle = (id) => {
    setOpenItems((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleCategory = (categoryKey) => {
    setOpenCategories((prev) => ({ ...prev, [categoryKey]: !prev[categoryKey] }));
  };

  const handleOpenModal = (buId) => {
    setSelectedFile({ buId });
    setIsNewModalOpen(true);
  };

  const handleFileClick = (message, buId) => {
    setSelectedFile({ ...message, buId });
    setIsNewModalOpen(true);
  };

  const getFileIcon = (filename) => {
    if (!filename) return <FaFile style={{ marginRight: 8 }} />;
    if (filename.endsWith('.pdf')) return <FaRegFilePdf style={{ marginRight: 8, color: '#D24726' }} />;
    if (filename.endsWith('.xls') || filename.endsWith('.xlsx')) return <FaRegFileExcel style={{ marginRight: 8, color: 'green' }} />;
    if (filename.endsWith('.doc') || filename.endsWith('.docx')) return <FaFileWord style={{ marginRight: 8, color: 'blue' }} />;
    if (filename.endsWith('.ppt') || filename.endsWith('.pptx')) return <FaFilePowerpoint style={{ marginRight: 8, color: '#D24726' }} />;
    return <FaFile style={{ marginRight: 8 }} />;
  };
return (
<Box sx={{ height: '80vh', overflow: 'auto', p: 2 }}>
  <Typography variant="h5" component="div" sx={{ color: '#1976d2', mb: 2 }}>
    <FileUploadIcon /> New取扱説明書_取込み
  </Typography>

  {loading ? (
    <CircularProgress />
  ) : (
    <List sx={{ width: "100%" }} dense>
      <Divider />

      {Object.entries(filebuList || {}).map(([buId, categories], index) => (
        <React.Fragment key={buId}>
          {index !== 0 && <Divider />}

          {/* BU 行（小さめ） */}
          <ListItem dense sx={{ py: 0.5, minHeight: "34px" }}>
            <ListItemButton onClick={() => handleToggle(buId)} sx={{ py: 0.3 }}>
              <ListItemText
                primary={buId}
                primaryTypographyProps={{ fontSize: 13 }}
              />

              <IconButton
                edge="end"
                size="small"
                sx={{ mr: 2, p: 0.5 }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenModal(buId);
                }}
              >
                <ControlPoint fontSize="small" />
              </IconButton>

              {openItems[buId] ? (
                <ExpandLess fontSize="small" />
              ) : (
                <ExpandMore fontSize="small" />
              )}
            </ListItemButton>
          </ListItem>

          <Divider sx={{ ml: 2 }} />

          <Collapse in={openItems[buId]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding dense>

              {Object.entries(categories).map(([category, messages]) => (
                <React.Fragment key={category}>

                  {/* Category 行（小さめ） */}
                  <ListItem
                    dense
                    button
                    sx={{ pl: 4, py: 0.4, minHeight: "32px" }}
                    onClick={() => toggleCategory(`${buId}-${category}`)}
                  >
                    <FaFolderOpen
                      style={{
                        marginRight: 8,
                        color: '#FFCC00',
                        fontSize: '16px'
                      }}
                    />

                    <ListItemText
                      primary={category || '未分類'}
                      primaryTypographyProps={{ fontSize: 12 }}
                    />

                    {openCategories[`${buId}-${category}`] ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </ListItem>

                  <Divider sx={{ ml: 4 }} />

                  <Collapse
                    in={openCategories[`${buId}-${category}`]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding dense>

                      {messages.map((message) => (
                        <React.Fragment key={message.id}>
                          {/* ファイル行（さらに小さめ） */}
                          <ListItem
                            dense
                            button
                            sx={{ pl: 6, py: 0.3, minHeight: "28px" }}
                            onClick={() => handleFileClick(message, buId)}
                          >
                            {getFileIcon(message.filename)}

                            <ListItemText
                              primary={message.filename}
                              primaryTypographyProps={{ fontSize: 12 }}
                            />
                          </ListItem>

                          <Divider sx={{ ml: 6 }} />
                        </React.Fragment>
                      ))}

                    </List>
                  </Collapse>

                </React.Fragment>
              ))}

            </List>
          </Collapse>

        </React.Fragment>
      ))}
    </List>
  )}

  <FileBUUploadModalNew
    open={isNewModalOpen}
    onClose={() => setIsNewModalOpen(false)}
    fileData={selectedFile || {}}
    filebuList={filebuList}
    type='cust'
    onUpdated={handleUpdateComplete}
  />
</Box>
);
};

export default SettingsDocUpNew;
